import Section from '../../../components/Modular/Section';
import Unit from '../../../components/Modular/Unit';
import MicroUnit from '../../../components/Modular/MicroUnit';
import { useAuth } from '../../../features/auth/hooks/useAuth';
import Button from '../../../components/Button/Button';

export function AdminHeader() {
  const { user, logout } = useAuth();

  async function handleLogout() {
    try {
      await logout();
    } catch (error) {
      console.error('Failed to log out:', error);
    }
  }

  return (
    <Section
      as="header"
      layout="flex"
      gap="lg"
      justifyContent="right"
      paddingTop="md"
    >
      <Unit layout="flex" alignItems="center" justifyContent="space-between">
        <MicroUnit as="p" pColor="light">
          Admin
        </MicroUnit>
      </Unit>

      <Unit>
        <MicroUnit as="p" pColor="light">
          Account
        </MicroUnit>
      </Unit>
      <Button variant="secondary" onClick={handleLogout}>
        <MicroUnit as="p">Logout</MicroUnit>
      </Button>
    </Section>
  );
}
